// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CustomEvent } from '@shared/utils/CustomEvents';
import { Resources } from '@shared/localizations/Resources';
import RangeSelectPanelTemplate from '@front/templates/RangeSelectPanelTemplate.html';
import { TerceraPanel } from '../elements/TerceraPanel';
import { DateTimeRangeOption, DateTimeUtils } from '@shared/utils/Time/DateTimeUtils';
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
export class RangeSelectPanel extends TerceraPanel {
    constructor() {
        super();
    }
    getType() {
        return 'RangeSelectPanel';
    }
    oninit() {
        super.oninit();
        this.getReportEvent = new CustomEvent();
    }
    oncomplete() {
        super.oncomplete();
        const combobox = this.Controls.rangeComboBox;
        combobox.observe('selectedItem', function (newValue) {
            this.selectRange(newValue);
        }.bind(this));
        const keys = RangeSelectPanel.rangeKeysArray;
        const items = [];
        keys.forEach((key) => {
            if (!Resources.isHidden(key)) {
                items.push({ type: NewContextMenuItemType.Default, text: key, value: key });
            }
        });
        combobox.set('items', items);
        this.on('applyBtnClick', () => {
            this.selectRange({ value: DateTimeRangeOption.RANGE });
        });
    }
    selectRange(selectedItem) {
        var _a, _b;
        if (isNullOrUndefined(selectedItem)) {
            return;
        }
        void this.set('dateRangeLookupVisibility', selectedItem.value === DateTimeRangeOption.RANGE);
        const dateFrom = (_a = this.get('dateFrom')) !== null && _a !== void 0 ? _a : new Date();
        const dateTo = (_b = this.get('dateTo')) !== null && _b !== void 0 ? _b : new Date();
        const rangeTimes = DateTimeUtils.getRangeByOption(selectedItem.value, dateFrom, dateTo);
        this.getReportEvent.Raise(rangeTimes.startTime, rangeTimes.finishTime);
    }
    updateSelectedRange() {
        this.selectRange(this.Controls.rangeComboBox.get('selectedItem'));
    }
    isDaily() {
        let key = DateTimeRangeOption.DAILY;
        let item = null;
        if (!isNullOrUndefined(this.Controls.rangeComboBox)) {
            item = this.Controls.rangeComboBox.get('selectedItem');
        }
        if (!isNullOrUndefined(item)) {
            key = item.value;
        }
        return key === DateTimeRangeOption.DAILY;
    }
}
RangeSelectPanel.rangeKeysArray = [
    DateTimeRangeOption.DAILY,
    DateTimeRangeOption.H24,
    DateTimeRangeOption.D7,
    DateTimeRangeOption.D30,
    DateTimeRangeOption.D90,
    DateTimeRangeOption.RANGE
];
TerceraPanel.extendWith(RangeSelectPanel, {
    template: RangeSelectPanelTemplate,
    data: function () {
        return {
            top: 5,
            left: 5,
            visible: true,
            cbTooltip: 'panel.rangeSelect.tooltip',
            dateRangeLookupVisibility: false,
            refreshBtnVisibility: false,
            refreshBtnTT: null,
            dateFrom: null,
            dateTo: null
        };
    }
});
